export const crosschainEstimationTimes = {
  "1": {
    "8453": 30 * 60 * 1000,
    "42161": 30 * 60 * 1000,
    "10": 30 * 60 * 1000,
    "137": 30 * 60 * 1000,
    "43114": 30 * 60 * 1000,
  },
  "8453": {
    "42161": 30 * 60 * 1000,
    "10": 30 * 60 * 1000,
    "1": 30 * 60 * 1000,
    "137": 30 * 60 * 1000,
    "43114": 30 * 60 * 1000,
  },
  "42161": {
    "8453": 30 * 60 * 1000,
    "10": 30 * 60 * 1000,
    "1": 30 * 60 * 1000,
    "137": 30 * 60 * 1000,
    "43114": 30 * 60 * 1000,
  },
  "10": {
    "8453": 30 * 60 * 1000,
    "42161": 30 * 60 * 1000,
    "1": 30 * 60 * 1000,
    "137": 30 * 60 * 1000,
    "43114": 30 * 60 * 1000,
  },
  "137": {
    "8453": 30 * 60 * 1000,
    "42161": 30 * 60 * 1000,
    "1": 30 * 60 * 1000,
    "137": 30 * 60 * 1000,
    "43114": 30 * 60 * 1000,
  },
  "43114": {
    "8453": 30 * 60 * 1000,
    "42161": 30 * 60 * 1000,
    "1": 30 * 60 * 1000,
    "137": 30 * 60 * 1000,
    "43114": 30 * 60 * 1000,
  },

  // testnets
  "43113": {
    "80001": 30 * 60 * 1000,
  },
  "80001": {
    "43113": 30 * 60 * 1000,
  },
};
